module.exports = __webpack_public_path__ + "static/media/icon-not-found@3x.4a2496b6.png";